function LaunchIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg className="icon-launch" viewBox="0 0 24 24" {...props}>
      <path
        d="M6.64 6.46h7.07a1 1 0 01.7 1.71l-4.24 4.24a1 1 0 01-.7.3H2.38A1 1 0 011.7 11l4.24-4.24a1 1 0 01.7-.3zm10.9 10.9a1 1 0 01-.3.71L13 22.31a1 1 0 01-1.7-.7v-7.07a1 1 0 01.29-.71l4.24-4.24a1 1 0 011.7.7v7.07z"
        className="secondary"
      />
      <path
        d="M5.78 13.19a15.94 15.94 0 0114.39-10.4 1 1 0 011.04 1.04 15.94 15.94 0 01-10.4 14.39 1 1 0 01-1.17-.37 14.1 14.1 0 00-3.5-3.5 1 1 0 01-.36-1.16zm.59 2.57a16.2 16.2 0 011.87 1.87 1 1 0 01-.47 1.6c-.79.25-1.6.42-2.4.54a1 1 0 01-1.14-1.13c.12-.82.3-1.62.53-2.41a1 1 0 011.6-.47z"
        className="primary"
      />
      <path
        d="M7.23 10.26a19.04 19.04 0 016.5 6.51c-.92.58-1.9 1.07-2.92 1.45a1 1 0 01-1.17-.37 14.1 14.1 0 00-3.5-3.5 1 1 0 01-.36-1.16c.38-1.03.87-2 1.45-2.93zM17.62 3.1c.84-.17 1.7-.27 2.55-.3a1 1 0 011.04 1.04c-.03.86-.13 1.71-.3 2.55a19.2 19.2 0 00-3.29-3.29zm-3.91 7.2a2 2 0 112.83-2.83 2 2 0 01-2.83 2.83z"
        className="secondary"
      />
    </svg>
  );
}

export default LaunchIcon;
